import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Terminals } from 'ff/debrief/components/sidebar/TracklogListItem';
import { formatFlightDate } from 'ff/debrief/utils';
import { FFCDLogbookEntry } from 'ff/debrief/models';
import { LogbookEntry } from 'shared/sharedTypes/logbook/LogbookEntryModels';

const LogbookEntryHeader = ({
    logbookEntry,
}: {
    logbookEntry: FFCDLogbookEntry | LogbookEntry;
}) => {
    const getFlightDate = (entry: FFCDLogbookEntry | LogbookEntry): string => {
        return 'flightDateString' in entry
            ? entry.flightDateString
            : entry.flightDate;
    };

    return (
        <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography
                component="span"
                color="#526f8a"
                sx={{
                    flexGrow: 1,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    marginRight: '6px',
                }}
            >
                <Terminals
                    to={logbookEntry.destinationAirport ?? 'N/A'}
                    from={logbookEntry.departureAirport ?? 'N/A'}
                />
            </Typography>
            <Typography
                component="span"
                color="#008CC4"
                sx={{ flexShrink: 0, marginRight: '10px' }}
            >
                {formatFlightDate(getFlightDate(logbookEntry))}
            </Typography>
        </Box>
    );
};
export default LogbookEntryHeader;
